import React, { Children, cloneElement, PropTypes, PureComponent } from 'react';
import { NOTIFICATION_CONTEXT_TYPES } from '../../../NotificationSystemProvider';
import EmptyState from '../../../common/components/EmptyState';
import PageTabs from '../../../components/layout/PageTabs';
import join from 'url-join';

export default class AdminTourneyDivisionList extends PureComponent {
  static contextTypes = {
    dao: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    ...NOTIFICATION_CONTEXT_TYPES
  };

  static propTypes = {
    tourney: PropTypes.object,
    params: PropTypes.shape({
      tourneyId: PropTypes.string,
      divisionId: PropTypes.string
    }).isRequired
  };

  static defaultProps = {};

  state = {
    divisions: null,
    promise: null
  };

  componentDidMount() {
    this.fetchDivisions(this.props.tourney);
  }

  componentWillReceiveProps({ tourney }) {
    if (tourney.id !== this.props.tourney.id) {
      this.fetchDivisions(tourney);
    }
  }

  fetchDivisions = ({ id: tourneyId }) => {
    const { dao, onError } = this.context;
    const { promise } = this.state;

    if (!!promise) {
      promise.cancel();
    }

    this.setState({
      divisions: null,
      promise: dao.divisions.getAll({ tourneyId, sort: 'A|name' })
        .then(
          divisions => this.setState({ divisions }, this.selectFirstDivision)
        )
        .catch(onError)
        .finally(
          () => this.setState({ promise: null })
        )
    });
  };

  selectFirstDivision = () => {
    const { divisions } = this.state;
    const { params: { divisionId } } = this.props;

    if (divisionId) {
      return;
    }

    if (!divisions || divisions.length === 0) {
      return;
    }

    this.selectDivision(divisions[ 0 ]);
  };

  selectDivision = ({ id }) => {
    const { router } = this.context;
    const { params: { tourneyId }, location } = this.props;

    router.replace({
      ...location,
      pathname: join('tourneys', tourneyId, 'brackets', id)
    });
  };

  render() {
    const { divisions, promise } = this.state;
    const { children, params: { divisionId } } = this.props;

    if (divisions === null) {
      if (promise === null) {
        return <EmptyState>Divisions could not be loaded!</EmptyState>;
      } else {
        return EmptyState.LOADING;
      }
    }

    if (divisions.length === 0) {
      return <EmptyState>No divisions in this tourney!</EmptyState>;
    }

    const division = divisionId ? _.findWhere(divisions, { id: divisionId }) : null;

    return (
      <div>
        <div style={{ backgroundColor: 'white', paddingTop: 10, borderBottom: '1px solid rgba(0,0,0,0.2)' }}>
          <div className="max-width">
            <PageTabs
              options={divisions.map(({ name }) => name)}
              active={_.indexOf(divisions, division)}
              onActiveChange={ix => this.selectDivision(divisions[ ix ])}
            />
          </div>
        </div>
        {
          division ?
            Children.map(children, child => cloneElement(child, { division })) :
            <EmptyState>Select a division</EmptyState>
        }
      </div>

    );
  }
}


// WEBPACK FOOTER //
// ./src/js/GameDay/components/pages/AdminTourneyDivisionList.jsx